/**
 * 로케일에 맞는 표시명을 고른다 — 이름 두 개(한글/영문)와 로케일만 받는 순수 함수.
 *
 * TRAD-2059(글로벌 지수·원자재 티커)에서 처음 만들었다: 서버가 `name`(영문)·`nameKo`(한글)를
 * 둘 다 내려주는데 `nameKo` 로 고정 렌더돼 EN 로케일에서도 "다우존스"가 나왔다.
 * TRAD-1954(크립토 마켓 검색/목록/관심종목)에서 같은 결함을 발견해 이 유틸로 승격했다 —
 * 그쪽은 `korean_name`/`english_name`(snake_case), 도메인마다 필드명이 갈려 있어(TRAD-2426
 * 잔여: `koreanName`/`englishName` camelCase 도 있음) **객체가 아니라 문자열 두 개**를 받는다.
 * 호출부가 자기 필드를 골라 넘기면 되므로 필드명 케이스와 무관하게 재사용된다.
 *
 * 클라 i18n 카탈로그 키로 뽑지 않는다 — 종목/코인 목록은 서버가 정하므로, 카탈로그에 없는
 * 신규 항목이 추가되면 빈칸이 된다. 서버가 준 두 이름 중 로케일에 맞는 쪽을 고르는 것이 맞다.
 * 한쪽이 비어 있으면 반대쪽으로 폴백한다(빈 라벨 방지).
 *
 * TRAD-2723 — 분기를 `locale === 'ko' ? KO : EN` 로 잡는다(종전엔 `locale === 'en' ? EN : KO`).
 * 지원하지 않는 3번째 로케일이 오면 **EN 으로 폴백**한다 — 표시 문구는 영어 폴백이 맞다는
 * 팀 결정(다른 판단이 필요한 `getIntlLocale` 숫자·날짜 포맷과는 다른 부류). 종전 분기는
 * "en 이 아니면 전부 한국어"라 미지 로케일을 한국어로 좁혔다(CLAUDE.md 폴백 규칙 위반 —
 * 모르는 값을 아는 상태로 대체 금지). ko/en 두 로케일의 결과는 이 변경으로 바뀌지 않는다
 * (`__tests__/display-name.test.ts` 양방향 테스트로 고정).
 */
export const pickLocalizedName = (
  koreanName: string | undefined | null,
  englishName: string | undefined | null,
  locale: string,
): string => (locale === 'ko' ? koreanName || englishName || '' : englishName || koreanName || '');
